import React, { memo } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";

const tooltipSx = (theme) => ({
  backgroundColor: theme.palette.primary.light,
  boxShadow: theme.shadows[2],
  fontSize: 11,
  borderRadius: "6px",
  color: "white"
});

const CustomizedTooltip = memo(({ title, tooltipClassName, arrowClassName, uppercase, children, hidden, ...rest }) => {
  return hidden ? (
    children
  ) : (
    <Tooltip
      title={title}
      componentsProps={{
        tooltip: {
          sx: (theme) => ({
            ...tooltipSx(theme),
            ...(uppercase && { textTransform: "uppercase" })
          }),
          className: tooltipClassName
        },
        arrow: {
          sx: { color: "primary.light" },
          className: arrowClassName
        }
      }}
      {...rest}
    >
      {children}
    </Tooltip>
  );
});

CustomizedTooltip.propTypes = {
  title: PropTypes.oneOfType([PropTypes.element.isRequired, PropTypes.string.isRequired]).isRequired,
  tooltipClassName: PropTypes.string,
  arrowClassName: PropTypes.string,
  uppercase: PropTypes.bool,
  children: PropTypes.element.isRequired,
  hidden: PropTypes.bool
};

CustomizedTooltip.defaultProps = {
  tooltipClassName: "",
  arrowClassName: "",
  hidden: false,
  uppercase: false
};

export default CustomizedTooltip;
